import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "src/app/auth/auth.service";
import { countryPhoneCodes } from "src/app/create-user/data/phone-codes";
import { PhoneVerificationService } from "src/service/phone-verification.service";
import { WindowService } from "src/service/window.service";

@Component({
  selector: "app-dialog-change-phone",
  templateUrl: "./dialog-change-phone.component.html",
  styleUrls: ["../../dashboard.style.scss"],
})
export class DialogChangePhoneComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private phoneVerificationService: PhoneVerificationService,
    private windowService: WindowService,
    private dialogRef: MatDialogRef<DialogChangePhoneComponent>
  ) {}

  phoneNumberForm: FormGroup;
  phoneCodes = countryPhoneCodes;
  phoneNumber;

  ngOnInit(): void {
    this.phoneNumberForm = new FormGroup({
      phoneCode: new FormControl("", Validators.required),
      phoneNumber: new FormControl("", Validators.required),
    });

    this.phoneVerificationService.recaptchaVerifier();
  }

  sendSms() {
    this.phoneNumber = `${this.phoneNumberForm.value.phoneCode}${this.phoneNumberForm.value.phoneNumber}`;

    this.authService
      .changePhoneNumberSendSms(
        this.phoneNumber,
        this.windowService.windowRef.recaptchaVerifier
      )
      .subscribe(
        (confirmationResult) => {
          this.windowService.windowRef.confirmationResult = confirmationResult;
        },

        (error) => this.dialogRef.close({ error })
      );
  }

  onOtpChange(smsCode) {
    if (smsCode.length === 6) {
      this.dialogRef.close({ smsCode, phoneNumber: this.phoneNumber });
    }
  }
}
